import {
  selectAlarms,
  selectTimeWarningAlarms,
} from '../spectrasWebSocketServer/spectrasWebSocketServerSlice';

import {
  Button,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemText,
  ListSubheader,
  Typography,
} from '@mui/material';
import NotificationAlarmListItem from './NotificationAlarmListItem';
import TimeWarningAlarmListItem from './TimeWarningListItem';
import { useAppSelector } from '../../app/hooks';
import { SocketAlarm } from '../spectrasWebSocketServer/types';
import { DeleteSweep } from '@mui/icons-material';
import React, { Fragment } from 'react';
import { AlarmWithIndex, TimeWarningAlarm } from './types';

interface Props {
  handleAlarmClicked: (alarm: SocketAlarm) => void;
  handleAlarmDeleted: (index: number) => void;
  handleAllAlarmsDeleted: () => void;
  handleTimeWarningAlarmDeleted: (index: number) => void;
}

const NotificationList = ({
  handleAlarmClicked,
  handleAlarmDeleted,
  handleAllAlarmsDeleted,
  handleTimeWarningAlarmDeleted,
}: Props) => {
  const alarms: SocketAlarm[] = useAppSelector(selectAlarms);
  const alarmsWithIndices: AlarmWithIndex[] = alarms
    .slice(-20)
    .reverse()
    .map((alarm, index) => ({
      alarm,
      index: alarms.length - 1 - index,
    }));
  const timeWarningAlarms: TimeWarningAlarm[] = useAppSelector(
    selectTimeWarningAlarms
  );
  const timeWarningsWithIndices: AlarmWithIndex[] = timeWarningAlarms
    .slice(-20)
    .reverse()
    .map((alarm, index) => ({
      alarm,
      index: timeWarningAlarms.length - 1 - index,
    }));

  const combinedAndSortedAlarms = [
    ...alarmsWithIndices,
    ...timeWarningsWithIndices,
  ].sort((alarm1, alarm2) =>
    alarm2.alarm.timestamp.localeCompare(alarm1.alarm.timestamp)
  );

  if (combinedAndSortedAlarms.length < 1) {
    return (
      <List subheader={<ListSubheader component='div'>Alarms</ListSubheader>}>
        <ListItem>
          <ListItemText>No New Notifications</ListItemText>
        </ListItem>
      </List>
    );
  }

  return (
    <List
      subheader={
        <ListSubheader disableSticky={true} component='div'>
          <Grid container alignItems='center' justifyContent='space-between'>
            <Grid item>
              <Typography>Alarms</Typography>
            </Grid>
            <Grid item>
              <Button
                aria-label='delete all'
                onClick={() => handleAllAlarmsDeleted()}
                startIcon={<DeleteSweep />}
                color='secondary'
              >
                Clear All
              </Button>
            </Grid>
          </Grid>
        </ListSubheader>
      }
    >
      {combinedAndSortedAlarms.map((alarm, index) =>
        'alarm_log_id' in alarm.alarm ? (
          <Fragment key={index}>
            <NotificationAlarmListItem
              alarm={alarm.alarm}
              index={alarm.index}
              handleAlarmClicked={handleAlarmClicked}
              handleAlarmDeleted={handleAlarmDeleted}
            />
            <Divider />
          </Fragment>
        ) : (
          <Fragment key={index}>
            <TimeWarningAlarmListItem
              timeWarningAlarm={alarm.alarm}
              index={alarm.index}
              handleAlarmDeleted={handleTimeWarningAlarmDeleted}
            />
            <Divider />
          </Fragment>
        )
      )}
    </List>
  );
};

export default NotificationList;
